/**
 * 绝对路径: D:/XXY/MeiShan_Project/frontend/packages/operator-admin/src/utils/passive-event-fix.ts
 * 版本: v1
 * 创建日期: 2026-01-19 17:53
 * 创建人: GPT-5.2 (Cursor)
 *
 * Passive Event Listener Polyfill
 *
 * 功能：
 * - 解决 Element Plus 组件（ElTable, ElScrollbar 等）触发的 Chrome Violation 警告
 * - 将 wheel/touchstart/touchmove 事件默认设为 passive（当未明确指定时）
 *
 * 注意：
 * - 此 polyfill 仅对未明确指定 passive 选项的监听器生效
 * - 如果组件需要调用 preventDefault()，应明确传入 { passive: false }
 */
export function installPassiveEventFix(): void {
  if (typeof window === 'undefined' || typeof EventTarget === 'undefined') return

  // 检查浏览器是否支持 passive 选项
  let supportsPassive = false
  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        supportsPassive = true
        return true
      }
    }) as AddEventListenerOptions
    const noop = () => {}
    window.addEventListener('testPassive', noop, opts)
    window.removeEventListener('testPassive', noop, opts)
  } catch {
    supportsPassive = false
  }

  if (!supportsPassive) return

  const passiveEvents = ['wheel', 'mousewheel', 'touchstart', 'touchmove']
  const originalAddEventListener = EventTarget.prototype.addEventListener

  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ): void {
    let modifiedOptions = options

    if (passiveEvents.includes(type)) {
      if (options === undefined || options === false) {
        modifiedOptions = { capture: false, passive: true }
      } else if (options === true) {
        modifiedOptions = { capture: true, passive: true }
      } else if (typeof options === 'object') {
        if (options.passive === undefined) {
          modifiedOptions = { ...options, passive: true }
        }
      }
    }

    return originalAddEventListener.call(this, type, listener, modifiedOptions)
  }

  if (import.meta?.env?.DEV) {
    console.info('[PassiveEventFix] Installed passive event listener polyfill (operator-admin)')
  }
}

